const TITLE_WEB = "SBT"
// const API_URL = "http://localhost:4030/api/"//"https://tabkaewbus.ugravity.net/api/"//.
const API_URL = "https://tabkaewbus.ugravity.net/api/"
export {
    TITLE_WEB,
    API_URL
}